import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { LoaderAnim } from '@sm360/widget-commons-basic-components';
import { ModalService, AccountService, AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import 'commons-vehicle/Quote/components/AddToGarageV25/AddToGarageButtonV25.scss';

import { noop } from 'lodash';

class AddToGarageButtonV25 extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);

        // this reference to this function must not change
        // because adding the callbacks check if this exact object exists
        this.onCloseCallBacks = {
            onClose: (params) => {
                const newAccount = params && params.newAccount;
                if (AccountService.isAuthenticated()) {
                    this.saveToGarage(newAccount);
                }
                return true;
            },
        };
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.garageQuotes !== this.props.garageQuotes || nextProps.quote !== this.props.quote;
    }

    onClick() {
        const { quote } = this.props;

        if (quote.vehicle) {
            AnalyticsService.gaTrigger(
                quote.vehicle.getIsVehicleNew()
                    ? TAGS.ADD_TO_GARAGE_CTA_NEW(quote.vehicle.model.name)
                    : TAGS.ADD_TO_GARAGE_CTA_USED(quote.vehicle.model.name)
            );
        }

        if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks(this.onCloseCallBacks);
            LoginModal.open({ submitAccountCreationLead: false });
        } else {
            this.saveToGarage();
        }
    }

    saveToGarage(newAccount) {
        if (AccountService.isAuthenticated()) {
            this.props.onClick(newAccount);
        }
        return true;
    }

    render() {
        const { quote } = this.props;
        const quoteId = quote?.id || UrlService.getUrlParameter('quoteId');
        const isQuoteInGarage = QuoteService.isQuoteInGarageV25(quoteId);
        const garageTitle = isQuoteInGarage
            ? LocaleService.t('QUOTE.BTN_APPLY_QUOTE_CHANGES')
            : LocaleService.t('QUOTE.BTN_ADD_TO_GARAGE');
        const garageButtonClasses = ['widget-vehicle-quote-btn-secondary', 'sr-button-outline-2'];
        const isDirty = isQuoteInGarage && quote.modified;
        const showButton = isDirty || !isQuoteInGarage;

        if (this.props.buttonClass) {
            garageButtonClasses.push(this.props.buttonClass);
        }
        if (isDirty) {
            garageButtonClasses.push('is-modify');
        }

        return (
            showButton && (
                <button
                    className={garageButtonClasses.join(' ')}
                    onClick={quote.loading ? noop : this.onClick}
                    title={garageTitle}
                    type="button"
                >
                    {quote.loading || this.props.loading ? (
                        <LoaderAnim />
                    ) : (
                        <div>
                            <icon className="icon-Mon-Garage" />
                            <span>{garageTitle}</span>
                        </div>
                    )}
                </button>
            )
        );
    }
}

AddToGarageButtonV25.defaultProps = {
    buttonClass: '',
};

AddToGarageButtonV25.propTypes = {
    buttonClass: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(QuoteModelV25).isRequired,
    garageQuotes: PropTypes.arrayOf(PropTypes.instanceOf(QuoteModelV25)),
};

AddToGarageButtonV25.displayName = 'AddToGarageButtonV25';

export default AddToGarageButtonV25;
